
import Modal from "@/components/base/modal/Modal"
import Button from "@/components/base/Button"

export default {
    name: "DeletionCheckModal",
    components: { Modal, Button },
    props: {
        deletionQuestion: {
            type: String,
            default: "Bist du dir sicher?",
        },
        showModal: {
            type: Boolean,
            default: false,
        },
    },
    methods: {},
}
